import React, { useEffect, useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import { useQuery } from '@tanstack/react-query';
import TabMenu from '../../components/tabMenu/TabMenu';
import AttendanceTab1 from './AttendanceTab1';
import AttendanceTab2 from './AttendanceTab2';
import MyButton from '../../components/myButton/MyButton';
import Popup from '../../components/popup/Popup';
// import FormAttendance from './FormAttendance';
import useAxios from '../../hooks/useAxios';
// import FormAttendance from './FormAttendance';
import AttendanceSideMenu from './AttendanceSideMenu';

const RequestAttendance = () => {
  const [selectedTab, setSelectedTab] = useState(1);
  const [popup1, setPopup1] = useState(false);
  const [listData, setListData] = useState([]);
  const [metaData, setMetaData] = useState({});
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);

  const api = useAxios();

  const { isLoading, error, data, refetch } = useQuery({
    queryKey: ['attendances', limit, page],
    queryFn: () =>
      api.get(`request/attendance/employee-request?limit=${limit}&page=${page}`).then((res) => {
        return res.data;
      }),
  });

  useEffect(() => {
    if (data) {
      setListData(data.data);
      setMetaData(data.meta);
    }
  }, [data]);

  const togglePopup1 = () => {
    setPopup1(!popup1);
  };

  const tabMenus = [
    {
      id: 1,
      name: 'Daftar Pengajuan Absensi',
      icon: 'event',
    },
    {
      id: 2,
      name: 'Riwayat Pengajuan',
      icon: 'history',
    },
  ];

  return (
    <div>
      <div className="d-flex justify-content-between mb-3 flex-column flex-md-row">
        <TabMenu
          setSelectedTab={setSelectedTab}
          selectedTab={selectedTab}
          data={0}
          menus={tabMenus}
        />
        <div className="d-flex align-items-center gap-3 mt-3 mt-md-0">
          <div>
            <MyButton type="add" text="Buat Pengajuan Absensi" action={togglePopup1} />
          </div>
        </div>
      </div>
      <Card className="rounded-4">
        <CardBody>
          <div className="d-flex flex-column gap-2">
            {selectedTab === 1 && (
              <AttendanceTab1
                {...{ isLoading, error, listData, metaData, refetch, setLimit, setPage }}
              />
            )}
            {selectedTab === 2 && <AttendanceTab2 />}
          </div>
        </CardBody>
      </Card>
      <Popup isOpen={popup1} togglePopup={togglePopup1} title="Form Pengajuan Absensi">
        {/* <FormAttendance togglePopup={togglePopup1} refetch={refetch} /> */}
        <AttendanceSideMenu togglePopup={togglePopup1} refetch={refetch} />
      </Popup>
    </div>
  );
};

export default RequestAttendance;
